import createReactComponent from '../createReactComponent';
export default createReactComponent('battery-empty', 'BatteryEmpty', [["path",{"d":"M18 7H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m3 4v2","key":"svg-0"}]]);